import React from "react";
import "./OurLeadsContent.css";
import cardData from "../../data/OurLeadsProfiles.js";
import FloatIcon from "../FloatIcons/FloatIcons";

function OurLeadsContent() {
  return (
    <>
      <div className="floatIconsContainer">
        <FloatIcon />
      </div>

      <div className="fame-banner-container">
        <img src="/images/OurTeam/Banner.png" alt="meet-our-team-banner" className="banner-walloffame" />
        <h1>Meet the Team</h1>
      </div>

      <div className="leads-container">
        <h2>Our Leads</h2>
        <div class="border-gradient horizontal-underline only-top"></div>
        <div className="leads-wrap">
          <div className="leads-row">
            {
              cardData.map((item) => {
                return (
                  <div className="leads-box">
                    <img src={item.profileImgPath} alt="lead-profile-picture" className="lead-dp" />
                    <h4 className="lead-name">{item.name}</h4>
                    <p className="lead-desig">{item.details}</p>
                    <div className="lead-links">
                      <a href={item.profileLink} target="_blank">
                        <img src="/images/OurTeam/icon1.png" alt="profile-link" className="profile-icons" />
                      </a>
                      <a href={item.linkdIn} target="_blank">
                        <img src="/images/OurTeam/icon2.png" alt="profile-link" className="profile-icons" />
                      </a>
                      <a href={"mailTo:" + item.mailTo}>
                        <img src="/images/OurTeam/icon3.png" alt="profile-link" className="profile-icons" />
                      </a>
                    </div>
                  </div>
                )
              })
            }

          </div>
          <div className="leads-badge-sec">
            <img src="/images/OurTeam/badge.png" alt="badge-icon" className="badge-icon" />
            <p>Team of Certified Language Trainers</p>
          </div>
        </div>
      </div>


    </>
  );
}

export default OurLeadsContent;
